import React, { useState } from 'react'

import { downloadPDFRIG, downloadAllPDF } from '../../../utils/utils'
import '../App.scss'
import { sanitizeHTML } from '../../../../shared/utils/common-utils'

const ASSET_AMPLOGO_BRAND = window.AMPMSSITEPATH + 'images/shared/Ameriprise_Financial_logo.jpg'
const ASSET_AMPLOGO_WHITE = window.AMPMSSITEPATH + 'images/shared/SOLID_WHITE_LOGO_SMALL.png'

const ResetButton = props => {
  return (
    <div>
      <button
        onClick={props.handleToolReset}
        className='header-button u-marginRight3gu Button Button--secondary'
        data-analytics='RIG-reset-tool'>
        <span className='header-button-text'>Reset Tool</span>
      </button>
    </div>
  )
}

const PrintButton = props => {
  return (
    <div>
      <button
        className='header-button u-marginRight3gu Button Button--secondary'
        onClick={props.togglePrintModalVisible}
        data-analytics='RIG-save-PDF'
        disabled={props.disable}>
        <span className='header-button-text'>{props.label}</span>
        {props.loading && (
          <div className='Loading u-marginLeft2gu'>
            <div className='Loading-indicator'></div>
            <div className='Loading-indicator'></div>
            <div className='Loading-indicator'></div>
          </div>
        )}
      </button>
    </div>
  )
}

const Modal = props => {
  return (
    <div className='Modal' role='dialog' aria-labelledby='modalTitle' aria-describedby='modalDesc'>
      <section className='Modal-window'>
        <div className='Modal-content Content' id='modalDesc'>
          <h3>
            To save a page to PDF:
            <button
              className='Modal-icon Modal-icon--inline'
              onClick={props.togglePrintModalVisible}>
              <span className='u-hiddenVisually'>Close this dialog</span>
            </button>
          </h3>
          <ol>
            <li className='u-marginBottom3gu u-textSizeMsrp1 u-textPrimary'>
              Click the <strong>Save PDF</strong> button below
            </li>
            <li className='u-marginBottom3gu u-textSizeMsrp1 u-textPrimary'>
              In your browser’s <strong>Print</strong> pop-up window, select{' '}
              <strong>Save as PDF</strong> from either the <strong>Printer</strong> or{' '}
              <strong>Destination</strong> field
            </li>
            <li className='u-marginBottom3gu u-textSizeMsrp1 u-textPrimary'>
              Click <strong>Save</strong>
            </li>
          </ol>
        </div>
        <footer className='Modal-footer'>
          <div className='ButtonRow'>
            <button
              className='Button Button--primary Button--small'
              onClick={props.performPrinting}>
              <span className='Icon--before' data-icon='&#xe415;'>
                Save PDF
              </span>
            </button>
            <button
              className='Button Button--secondary Button--small is-destructive'
              onClick={props.togglePrintModalVisible}>
              Cancel
            </button>
          </div>
        </footer>
      </section>
    </div>
  )
}

const mainHeader = {
  wrapperClasses: 'PageHeader u-padding0 u-pt-hidden u-bgColorBrand',
  imageSrc: ASSET_AMPLOGO_WHITE,
}

const setupHeader = {
  wrapperClasses: 'PageHeader u-padding0 u-bgColorWhite',
  imageSrc: ASSET_AMPLOGO_BRAND,
}

const Header = props => {
  //const pathname = window.location.pathname;
  const allSplitLocation = window.location.pathname.split('/')
  const splitLocation = allSplitLocation.filter(item => item !== '')
  const [printModalVisible, setPrintModalVisible] = useState(false)
  const [allPagesPrinting, setAllPagesPrinting] = useState(false)
  const [singlePagePrinting, setSinglePagePrinting] = useState(false)

  const lastParam = splitLocation[splitLocation.length - 1]
  let setupPage = lastParam === 'setup'
  let welcomePage = lastParam === 'retirement-income-guide'

  const togglePrintModalVisible = () => {
    setPrintModalVisible(!printModalVisible)
  }

  const printContent = () => {
    setSinglePagePrinting(true)
    downloadPDFRIG(lastParam, setSinglePagePrinting)
  }

  const printAllContent = () => {
    setAllPagesPrinting(true)
    downloadAllPDF(splitLocation[splitLocation.length - 2], setAllPagesPrinting)
  }

  const performPrinting = () => {
    // Set the app title to default the document name in the browser's save dialog
    const oldTitle = document.title
    let pageTitleHyphenatedWords = splitLocation[1].split('-')
    const capitalizeAndConcatenate = array => {
      let string = ''
      array.forEach(word => {
        let capitalizedWord = word[0].toUpperCase() + word.slice(1)
        string += capitalizedWord
      })
      return string
    }
    document.title = `RetirementIncomeConversationGuide-${capitalizeAndConcatenate(
      pageTitleHyphenatedWords
    )}.pdf`

    try {
      window.print()
    } finally {
      // And repair the title
      document.title = sanitizeHTML(oldTitle)
      togglePrintModalVisible()
    }
  }

  return (
    <header className={!setupPage ? mainHeader.wrapperClasses : setupHeader.wrapperClasses}>
      <div className='u-sizeConstrained'>
        <div className='u-flex u-flexRow u-flexJustifyEnd u-flexAlignItemsCenter'>
          {printModalVisible && (
            <Modal
              performPrinting={performPrinting}
              togglePrintModalVisible={togglePrintModalVisible}
            />
          )}
          {!setupPage && !welcomePage && (
            <PrintButton
              togglePrintModalVisible={printAllContent}
              label={'Download All'}
              loading={allPagesPrinting}
              disable={allPagesPrinting || singlePagePrinting}
            />
          )}
          {!setupPage && !welcomePage && (
            <PrintButton
              togglePrintModalVisible={printContent}
              label={'Download Page'}
              loading={singlePagePrinting}
              disable={allPagesPrinting || singlePagePrinting}
            />
          )}
          {!setupPage && <ResetButton handleToolReset={props.handleToolReset} />}
          <div className='u-pt-block'>
            <a href='https://ameriprise.com'>
              <img
                alt='Ameriprise Logo'
                className='header-site-logo u-paddingVert2gu'
                src={!setupPage ? mainHeader.imageSrc : setupHeader.imageSrc}
              />
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
